export const entrypoint = "https://api.poissonsdedombes.preprod.acheteza.fr";
export const baseUrl = "https://api.poissonsdedombes.preprod.acheteza.fr";
